import currency from 'currency.js';
import { GameId } from '@bg-shared/enums/GameId';
import { Store } from '@betgames/bg-state-manager';
import { StoresEntity } from '@bg-shared/business/StoreFeature';

export const totalBetAmountEntity = new StoresEntity(
    class TotalBetAmount extends Store<number> {
        constructor(gameId: GameId) {
            super({
                key: `TotalBetAmount/${gameId}`,
                default: 0,
            });
        }

        public increase(amount: number): void {
            this.update((draft) => currency(draft).add(amount).value);
        }
    },
);
